import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import type { Promocode } from '@/types/order.types';

dayjs.extend(isBetween);

/** True when "now" falls within the promo's [startDate, endDate] window. */
export function isPromoActive(promo: Promocode): boolean {
  return dayjs(new Date().toISOString()).isBetween(promo.startDate, promo.endDate);
}

/**
 * Discount for a single base amount. `fixed_discount` subtracts a flat value;
 * `%_discount` subtracts a percentage. Savings are clamped to `base` so the
 * discounted total is never negative.
 */
export function computePromoDiscount(
  promo: Promocode,
  base: number,
): { savings: number; discountedTotal: number } {
  const raw =
    promo.discountType === '%_discount'
      ? (base * promo.discountValue) / 100
      : promo.discountValue;
  const savings = Math.min(Math.max(raw, 0), base);
  return { savings, discountedTotal: base - savings };
}
